module.exports = __webpack_public_path__ + "static/lock-eaba7a77f13265673b9bd51f22c6522c.png";